import type { SelectionGeometry } from "src/js/stores/map/store";
import { geoJsonPolyToGoogleBounds } from "src/js/util/map_util";
import { MOBILE_BREAKPOINT } from "../theme/Theme";
import {
  EXPLORER_WIDTH_DESKTOP,
  LOCATION_SEARCH_HEIGHT_MOBILE,
  NAVBAR_HEIGHT_MOBILE,
  WORKBENCH_HEIGHT_MOBILE,
  WORKBENCH_WIDTH_DESKTOP,
} from "react-migration/constants";

type NavigateToGeometryProps = {
  geometry?: SelectionGeometry | null;
  googleMap?: google.maps.Map | null;
  showLHP?: boolean;
  showRHP?: boolean;
  leftOffset?: number;
  rightOffset?: number;
  bottomOffset?: number;
  topOffset?: number;
};

export const navigateToGeometry = ({
  geometry,
  googleMap,
  leftOffset,
  rightOffset,
  topOffset,
  bottomOffset,
  showLHP,
  showRHP,
}: NavigateToGeometryProps) => {
  if (!googleMap || !geometry) return;

  const isMobile = window.innerWidth < MOBILE_BREAKPOINT;
  const { top, bottom } = getMobilePanels({ topOffset, bottomOffset });
  const { left, right } = getDesktopPanels({ leftOffset, rightOffset, showLHP, showRHP });

  if (geometry.type === "Polygon" || geometry.type === "MultiPolygon") {
    const bounds = geoJsonPolyToGoogleBounds(geometry);
    if (isMobile) {
      googleMap.fitBounds(bounds, { top, bottom });
    } else {
      googleMap.fitBounds(bounds, { left, right });
    }
  } else if (geometry.type === "Point") {
    const [lng, lat] = geometry.coordinates;
    if (typeof lng !== "number" || typeof lat !== "number") return;
    googleMap.setCenter({ lng, lat });
    if (isMobile) {
      googleMap.panBy(0, bottom / 2 - top / 2);
    }
  }
};

type GetPanels = {
  showLHP?: boolean;
  showRHP?: boolean;
  leftOffset?: number;
  rightOffset?: number;
  topOffset?: number;
  bottomOffset?: number;
};
const getDesktopPanels = ({ showLHP, showRHP, leftOffset, rightOffset }: GetPanels) => ({
  left: showLHP ? leftOffset ?? EXPLORER_WIDTH_DESKTOP : 0,
  right: showRHP ? rightOffset ?? WORKBENCH_WIDTH_DESKTOP : 0,
});

const getMobilePanels = ({ topOffset, bottomOffset }: GetPanels) => ({
  top: topOffset ?? LOCATION_SEARCH_HEIGHT_MOBILE,
  bottom:
    ((window.innerHeight - NAVBAR_HEIGHT_MOBILE) / 100) * (bottomOffset ?? WORKBENCH_HEIGHT_MOBILE) +
    NAVBAR_HEIGHT_MOBILE,
});
